import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import CategoryIcon from "@mui/icons-material/Category";
import LayersIcon from "@mui/icons-material/Layers";
import InventoryIcon from "@mui/icons-material/Inventory";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
// https://admin.onlinepharmaque.in/
const API_BASE = "https://mediapi.onlinepharmaque.in/api/v1";

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [categoryCount, setCategoryCount] = useState(0);
  const [subcategoryCount, setSubcategoryCount] = useState(0);
  const [productCount, setProductCount] = useState(0);

  useEffect(() => {
    fetchCategories();
    fetchSubCategories();
    fetchProducts();
  }, []);

const fetchCategories = () => {
  fetch(`${API_BASE}/getcategory`)
    .then((res) => res.json())
    .then((data) => setCategoryCount(data?.result?.length || 0))
    .catch(() => toast.error("Failed to load categories"));
};




  const fetchSubCategories = async () => {
    try {
      const res = await fetch(`${API_BASE}/getsubcategory`);
      const data = await res.json();
      setSubcategoryCount(data?.result?.length || 0);
    } catch (error) {
      toast.error("Failed to load subcategories");
    }
  };

  const fetchProducts = async () => {
    try {
      const res = await fetch(`${API_BASE}/getAllProduct`);
      const data = await res.json();
      setProductCount(data?.result?.length || 0);
    } catch (error) {
      toast.error("Failed to load products");
    }
  };

  return (
    <Box m="20px">
      {/* HEADER */}
      <Header title="DASHBOARD" subtitle="Welcome to your dashboard" />

      {/* DASHBOARD CARDS */}
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap="20px"
        mt={3}
      >
        {/* Categories */}
        <Box
          gridColumn="span 4"
          sx={{
            background: "linear-gradient(135deg, #1e3c72, #2a5298)",
            borderRadius: "18px",
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 12px 25px rgba(0,0,0,0.35)",
            transition: "0.3s",
            "&:hover": {
              transform: "translateY(-6px)",
              boxShadow: "0 20px 40px rgba(0,0,0,0.45)",
            },
          }}
        >
          <Box>
            <Typography variant="h6" sx={{ opacity: 0.8 }}>
              Categories
            </Typography>
            <Typography variant="h3" fontWeight="bold">
              {categoryCount}
            </Typography>
          </Box>

          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CategoryIcon fontSize="large" />
          </Box>
        </Box>

        {/* Subcategories */}
        <Box
          gridColumn="span 4"
          sx={{
            background: "linear-gradient(135deg, #134E5E, #71B280)",
            borderRadius: "18px",
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 12px 25px rgba(0,0,0,0.35)",
            transition: "0.3s",
            "&:hover": {
              transform: "translateY(-6px)",
              boxShadow: "0 20px 40px rgba(0,0,0,0.45)",
            },
          }}
        >
          <Box>
            <Typography variant="h6" sx={{ opacity: 0.8 }}>
              Subcategories
            </Typography>
            <Typography variant="h3" fontWeight="bold">
              {subcategoryCount}
            </Typography>
          </Box>

          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LayersIcon fontSize="large" />
          </Box>
        </Box>

        {/* Products */}
        <Box
          gridColumn="span 4"
          sx={{
            background: "linear-gradient(135deg, #42275a, #734b6d)",
            borderRadius: "18px",
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 12px 25px rgba(0,0,0,0.35)",
            transition: "0.3s",
            "&:hover": {
              transform: "translateY(-6px)",
              boxShadow: "0 20px 40px rgba(0,0,0,0.45)",
            },
          }}
        >
          <Box>
            <Typography variant="h6" sx={{ opacity: 0.8 }}>
              Products
            </Typography>
            <Typography variant="h3" fontWeight="bold">
              {productCount}
            </Typography>
          </Box>

          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <InventoryIcon fontSize="large" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
